// removed by extract-text-webpack-plugin
module.exports = {"title":"Title-module__title___xjkiE"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/Title/Title.module.css
// module id = 655
// module chunks = 0